/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  GenericDeputyCenterLogic,
  GenericDeputyCenterLogicInterface,
} from "../../../../contracts/dependant/deputyCenter/GenericDeputyCenterLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "accessControl",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "calledAndCaller",
    outputs: [
      {
        internalType: "bool",
        name: "called",
        type: "bool",
      },
      {
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "target",
            type: "address",
          },
          {
            internalType: "bytes",
            name: "callData",
            type: "bytes",
          },
          {
            internalType: "uint256",
            name: "value",
            type: "uint256",
          },
        ],
        internalType: "struct GenericDeputyCenterType.BatchTransactions[]",
        name: "bTxs",
        type: "tuple[]",
      },
    ],
    name: "dispatchTransactions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GenericDeputyCenterLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GenericDeputyCenterLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GenericDeputyCenterLogic__factory extends ContractFactory {
  constructor(...args: GenericDeputyCenterLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<GenericDeputyCenterLogic> {
    return super.deploy(overrides || {}) as Promise<GenericDeputyCenterLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GenericDeputyCenterLogic {
    return super.attach(address) as GenericDeputyCenterLogic;
  }
  override connect(signer: Signer): GenericDeputyCenterLogic__factory {
    return super.connect(signer) as GenericDeputyCenterLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GenericDeputyCenterLogicInterface {
    return new utils.Interface(_abi) as GenericDeputyCenterLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GenericDeputyCenterLogic {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as GenericDeputyCenterLogic;
  }
}
